import type {SearchCategoryFilter} from "./api/types";

export function categoryFilterKey(filter?: SearchCategoryFilter | null): string {
  if(!filter?.c) return "";
  return [filter.c, filter.sub, filter.subsub, filter.subsubsub].filter(Boolean).join("/");
}

export function sameCategoryFilter(a?: SearchCategoryFilter | null, b?: SearchCategoryFilter | null): boolean {
  return categoryFilterKey(a) === categoryFilterKey(b);
}
